import React from "react";
import {
  Box,
  Stack,
  Text,
  Columns,
  Column,
  TextField,
} from "@origin-digital/ods-core";
import { Field, FieldInputProps, FieldMetaProps } from "formik";
import styled from "styled-components";
import { FormValues } from "../types";

const StyledText = styled(Text)`
  font-size: 17px;
`;

interface HomeUserAspBlockProps {
  meterProvider: string;
}

const HomeUserAspBlock = ({ meterProvider }: HomeUserAspBlockProps) => {
  return (
    <Stack space="large">
      <Text weight="medium">Accredited service provider</Text>
      <Stack space="xxlarge">
        <Columns
          collapseBelow="md"
          space={{ xs: "xlarge", md: "medium" }}
          alignY="stretch"
        >
          <Column width="1/2">
            <Stack space={{ xs: "xlarge", md: "xxlarge" }}>
              <Field name="homeUserAsp.firstName">
                {({
                  field,
                  meta,
                }: {
                  field: FieldInputProps<string>;
                  meta: FieldMetaProps<FormValues>;
                }) => (
                  <TextField
                    {...field}
                    id={field.name}
                    variant="outlined"
                    label="First name"
                    hideHelperTextSpace
                    error={!!meta.error}
                    helperText={meta.error}
                  />
                )}
              </Field>
            </Stack>
          </Column>
          <Column width="1/2">
            <Stack space={{ xs: "xlarge", md: "xxlarge" }}>
              <Field name="homeUserAsp.lastName">
                {({
                  field,
                  meta,
                }: {
                  field: FieldInputProps<string>;
                  meta: FieldMetaProps<FormValues>;
                }) => (
                  <TextField
                    {...field}
                    id={field.name}
                    variant="outlined"
                    label="Last name"
                    hideHelperTextSpace
                    error={!!meta.error}
                    helperText={meta.error}
                  />
                )}
              </Field>
            </Stack>
          </Column>
        </Columns>
        <Columns
          collapseBelow="md"
          space={{ xs: "none", md: "xlarge" }}
          alignY="stretch"
        >
          <Column>
            <Stack space={{ xs: "xlarge", md: "xxlarge" }}>
              <Field name="homeUserAsp.licenseNumber">
                {({
                  field,
                  meta,
                }: {
                  field: FieldInputProps<string>;
                  meta: FieldMetaProps<FormValues>;
                }) => (
                  <TextField
                    {...field}
                    id={field.name}
                    variant="outlined"
                    label="Accreditation number"
                    hideHelperTextSpace
                    error={!!meta.error}
                    startIcon={
                      <Box marginTop="none">
                        <StyledText>
                          {meterProvider === "ACUMENMPB" ? "IH#" : "FSP"}
                        </StyledText>
                      </Box>
                    }
                    helperText={
                      meta.error ||
                      (meterProvider === "ACUMENMPB"
                        ? "Electrician's accreditation number e.g. IH#12345"
                        : "Electrician's accreditation number e.g. FSP123")
                    }
                  />
                )}
              </Field>
            </Stack>
          </Column>
        </Columns>
      </Stack>
    </Stack>
  );
};

export default HomeUserAspBlock;
